import { AccessError } from 'routes/types';
import { ERRORS_ENUM } from 'routes/enums';

export const NotPermittedError = (message: string = 'You are not authorised to see this page.'): AccessError => {
  return {
    code: ERRORS_ENUM.NOT_AUTHORISED,
    message,
  };
};

export const NotFoundError = (message: string = 'Page you are looking for could not be found.'): AccessError => {
  return {
    code: ERRORS_ENUM.NOT_FOUND,
    message,
  };
};

export const PageNotMappedError = (): AccessError => {
  return {
    code: ERRORS_ENUM.NOT_MAPPED,
    message: 'Redirecting to default route.',
  };
};

export const UserNotLoggedError = (): AccessError => {
  return {
    code: ERRORS_ENUM.USER_NOT_LOGGED,
    message: 'Redirecting to default route.',
  };
};
